import React from 'react';
import { formatNumber } from '../../../../../../utils/currency';
import { FeesWrapper, BeneficiaryBoxWrapper, Flex } from '../../../styles';
import { ReactComponent as ArrowUp } from '../../../assets/icons/arrowUp.svg';

interface Props {
    text: string;
    fee: any;
    currencySymbol?: string;
}

interface BeneficiaryProps {
    amount: number
    currencySymbol?: string;
}

export const Fees = ({ text, fee, currencySymbol }: Props) => {
    return (
        <FeesWrapper>
            <span>{currencySymbol}{" "}{formatNumber(fee)}</span>
            <span>{text}</span>
        </FeesWrapper>
    )
}

export const BeneficiaryBox = ({ amount, currencySymbol }: BeneficiaryProps) => {
    return (
        <BeneficiaryBoxWrapper>
            <Flex>
                <ArrowUp />
                <div>
                    <span>Beneficiary gets</span>
                    <h1>{currencySymbol}{" "}{formatNumber(amount)}</h1>
                </div>

            </Flex>

        </BeneficiaryBoxWrapper>
    )

}